import { useEffect } from 'react';

import {
	useCloseAndAddIssuesToPage,
	useResetCloseAndAddIssuesToPage,
} from '../providers/BulkCreateContextProvider.tsx';

import { useGetIssueInsertionActions } from './useGetIssueInsertionActions.tsx';

export const useHandleCloseAndAddIssuesToPage = (onClose: () => void) => {
	const shouldClose = useCloseAndAddIssuesToPage();
	const { addSingleIssuesToPage } = useGetIssueInsertionActions();
	const resetCloseAndAddIssuesToPage = useResetCloseAndAddIssuesToPage();

	useEffect(() => {
		if (shouldClose) {
			void addSingleIssuesToPage();
			onClose();
			// Reset the state after closing
			void resetCloseAndAddIssuesToPage();
		}
	}, [shouldClose, onClose, addSingleIssuesToPage, resetCloseAndAddIssuesToPage]);
};
